export function isEmbeddedInIframe() {
  return window.parent !== window;
}
